import { observer } from 'mobx-react';
import useStores from '$src/hooks/useStores';
import OnboardingContainer from '$src/components/OnboardingContainer';
import { StarkIcon } from '@ring-icons';
import { redirectToOnboardingIntroduction } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useLocationContext from '$src/hooks/useLocationContext';
import aboutImage from '$src/assets/img/onboardingAbout.png';

import './index.less';

function OnboardingError() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      title="Sorry! We couldn’t activate Virtual Security Guard. Please tap retry so we can try that once more."
      handleClose={() => handleBackToRingDashboard(isMobile)}
      handleBack={() => redirectToOnboardingIntroduction(locationId)}
      icon={StarkIcon}
      headerTitle="Virtual Security Guard"
      image={aboutImage}
      data-testid="onboarding-error"
      primaryText="Try Again"
      primaryActionHandler={() => redirectToOnboardingIntroduction(locationId)}
      warningOnClose
    >
      <div className="onboarding-container__wrapper__content-children">
        <p>
          An error occurred, and we weren't able to activate Virtual Security Guard at this moment.
          <br />
          <br />
          Tap <b>Try Again</b> so we can activate your service. If the error persists please try again later
        </p>
      </div>
    </OnboardingContainer>
  );
}

export default observer(OnboardingError);
